import React, { useState } from 'react';
import { Play } from 'lucide-react';

const ProjectVideo = () => {
    const [isPlaying, setIsPlaying] = useState(false);
    const videoId = "SkWvKhldYHI";
    const videoThumbnail = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
    const embedUrl = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&mute=0&rel=0&modestbranding=1&controls=1`;

    return (
        <section id="project-video" className="py-20 bg-gray-50 overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-3xl sm:text-4xl font-light text-gray-900 mb-4 tracking-tight">
                        Experience <span className="text-[var(--primarycolor)] font-normal">Dignity Living</span>
                    </h2>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Take a visual journey through our premium retirement community and see what makes us special.
                    </p>
                </div>

                <div className="relative max-w-5xl mx-auto">
                    {/* Video Container with Simple Styling */}
                    <div className="relative aspect-video rounded-3xl overflow-hidden border border-gray-200 group">
                        {!isPlaying ? (
                            // Thumbnail and Play Button Overlay
                            <div 
                                className="absolute inset-0 cursor-pointer overflow-hidden"
                                onClick={() => setIsPlaying(true)}
                            >
                                <img 
                                    src={videoThumbnail} 
                                    alt="Project Video Thumbnail"
                                    className="w-full h-full object-cover transition-transform duration-700"
                                />
                                {/* Overlay Gradient */}
                                <div className="absolute inset-0 bg-black/10 transition-colors duration-300"></div>
                                
                                {/* Simple Play Button */}
                                <div className="absolute inset-0 flex items-center justify-center">
                                    <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white/90 text-[var(--primarycolor)] rounded-full flex items-center justify-center transition-all duration-300 group-hover:bg-white">
                                        <Play className="w-6 h-6 sm:w-8 sm:h-8 fill-current ml-1" />
                                    </div>
                                </div>
                                
                                {/* Bottom Info Bar */}
                                <div className="absolute bottom-0 inset-x-0 p-6 bg-gradient-to-t from-black/60 to-transparent">
                                    <p className="text-white text-base font-medium">Watch the Project Overview</p>
                                </div>
                            </div>
                        ) : (
                            // YouTube Iframe
                            <iframe
                                src={embedUrl}
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                                className="w-full h-full"
                            ></iframe>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProjectVideo;
